import { cn } from "@omni/utils/styles";

import { Card } from "@/components/General/Card/card.component";
import { CardBody } from "@/components/General/Card/cardBody.component";
import { CardTitle } from "@/components/General/Card/cardTitle.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { formatISO } from "@/utils/date";
import { formatPrice } from "@/utils/price.utils";

type Props = {
    balance: number;
    expirationDate: string;
};

const GiftCardBalance = ({ balance, expirationDate }: Props) => {
    const { t } = useGranite();

    return (
        <Card>
            <CardBody>
                <CardTitle tag="h2">
                    {t("general.giftCardRequestBalance.title")}
                </CardTitle>
                <p>
                    <span>{t("general.giftCardRequestBalance.balance")}: </span>
                    <span
                        className={cn("tw:font-bold tw:text-danger tw:text-lg")}
                    >
                        {formatPrice(balance)}
                    </span>
                </p>
                <p>
                    <span>
                        {t("general.giftCardRequestBalance.expirationDate")}:{" "}
                    </span>
                    <span
                        className={cn("tw:font-bold tw:text-danger tw:text-lg")}
                    >
                        {formatISO(expirationDate)}
                    </span>
                </p>
            </CardBody>
        </Card>
    );
};

export default GiftCardBalance;
